import Result from "@/core/common/Result";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { IDefaultContabilResponse } from "@/features/contabil/services/types";
import { ContabilGatewayError } from "../../diagnostico/config/ContabilGatewayError";
import {
  ICriarAgendamentoGateway,
  SalvarAgendamentoParams
} from "../ports/CriarAgendamentoGateway";

@injectable()
export class CriarAgendamentoGatewayAdapter
  extends ContabilGatewayError
  implements ICriarAgendamentoGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  private readonly httpClient!: HttpClient;

  async criarAgendamento(
    params: SalvarAgendamentoParams
  ): Promise<Result<void>> {
    try {
      const response = await this.httpClient.post<
        IDefaultContabilResponse<void>
      >({
        url: "v1/contabil/agendamentos/criar-agendamento",
        body: params
      });

      if (this.hasError(response)) {
        this.handleErrors(response);

        return Result.fail("Não foi possível agendar");
      }

      return Result.ok();
    } catch (_e) {
      return Result.fail(this.DEFAULT_ERROR);
    }
  }
}
